import "../../assets/css/read-more.css";
import React, { useState, useRef, useEffect } from "react";
import useMediaQuery from "../Hooks/useMediaQuery";

function ReadMore(props) {
  const { children, readMoreButton, showMobileOnly=true, initialHeight, parentScrollRef=null } = props;
  const { deviceScreen } = useMediaQuery();
  const smallScreen = ["x-small", "small"].includes(deviceScreen);

  const readMoreContainer = useRef();

  const calculatedHeight = () => {
    //calculate height of all the children!
    let children = [...readMoreContainer.current.children];
    let height = 0;
    children.forEach((child) => (height += child.offsetHeight));
    return height;
  };

  const [maxHeight, setMaxHeight] = useState(initialHeight);
  const [hideReadMore, setHideReadMore] = useState(false);
  const [readMoreStyles, setReadMoreStyles] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
    setMaxHeight(isOpen ? initialHeight : calculatedHeight());
    if (isOpen && smallScreen) {
      parentScrollRef 
        ? parentScrollRef.current.scrollIntoView() 
        : readMoreContainer.current.scrollIntoView();
    }
  };

  useEffect(() => {
    if (!smallScreen && showMobileOnly) {
      setHideReadMore(true);
      setReadMoreStyles({});
    } else {
      setHideReadMore(initialHeight >= calculatedHeight());
      setReadMoreStyles({
        style: {
          maxHeight: isOpen ? `${maxHeight}px` : `${initialHeight}px`,
        },
      });
    }
  }, [smallScreen, maxHeight]);

  return (
    <React.Fragment>
      <div
        className="ReadmoreContainer"
        {...readMoreStyles}
        ref={readMoreContainer}
      >
        {children}
        {hideReadMore ? null : (
          <div
            className="ReadMoreGradient"
            style={{
              opacity: isOpen ? 0 : 1,
            }}
          />
        )}
      </div>

      {hideReadMore
        ? null
        : readMoreButton({
            isOpen,
            onClick: () => toggle(),
          })}
    </React.Fragment>
  );
}

export default ReadMore;
